import { ContextMetadata } from '@lib.core/entities/indicator/context-metadata';

export class ContextMetadataDTO {
  isMultiSector!: boolean;
  isMultiIndustry!: boolean;
  isMultiOccupation!: boolean;
  isMultiProduct!: boolean;

  static toContextMetadata(contextMetadataDTO: ContextMetadataDTO): ContextMetadata {
    const { isMultiSector, isMultiIndustry, isMultiOccupation, isMultiProduct } = contextMetadataDTO;
    return new ContextMetadata(isMultiSector, isMultiIndustry, isMultiOccupation, isMultiProduct);
  }
}